import { z } from 'zod'

import { ApplicationError, type Team } from '../domain'

export abstract class ForManagingTeams {
	static CreateTeam = z.object({
		name: z
			.string()
			.min(3, { message: 'The name must be at least 3 characters long' })
			.max(36, { message: 'The name must be at most 36 characters long' })
			.regex(/^[a-zA-Z]/, { message: 'The name must start with a letter' })
			.regex(/^(?!.*[- ]$)(?!^[- ])/, {
				message: 'The name cannot start or end with a space or hyphen'
			})
			.regex(/^[a-zA-Z0-9-\s]+$/, {
				message:
					'The name can only contain letters, numbers, spaces, and hyphens'
			})
	})

	abstract fetchTeams(): Promise<{
		data?: Team[]
		error?: ApplicationError
	}>

	abstract fetchTeam(id: string): Promise<{
		data?: Team
		error?: ApplicationError
	}>

	abstract createTeam(
		params: z.infer<typeof ForManagingTeams.CreateTeam>
	): Promise<{
		data?: Team
		error?: ApplicationError
	}>
}
